<template>
  <div class="page">
    <PageHeader>
      Пользователи
    </PageHeader>
    <div class="content" v-if="loaded">
      <UsersTableComponent />
    </div>
  </div>
</template>
<script>
import UsersTableComponent from "./components/UsersTable";
import PageHeader from "../../ui/PageHeader.vue";
export default {
  name: "Users",
  components: { PageHeader, UsersTableComponent },
  data: () => ({
    loaded: true
  })
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Users/index.vue